import { AvailableDocument } from '../../interfaces/AvailableDocument';
import { DocumentDefinitionDto } from '../../interfaces/Dto/DocumentDefinitionDto';

export default function transformAvailableDocuments(dtos: DocumentDefinitionDto[]): AvailableDocument[] {
  const availableDocuments: AvailableDocument[] = [];
  dtos?.forEach((dto) => {
    availableDocuments.push({
      name: dto.name,
    });
  });
  return availableDocuments.sort(compare);
}

function compare(a: AvailableDocument, b: AvailableDocument) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}
